import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/common-services/common-service';
import { faBell, faBars } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators'
//translation service
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from 'src/app/common-services/translation.service';
import{HeaderComponent} from 'src/app/components/header/header.component';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.css']

})
export class DashboardComponent implements OnInit {
	iconNotification = faBell;
	iconMenu = faBars;

	//translation
	browserLang: any;


	isMenuCollapsed = window.innerWidth <= 768;
	showGlobalHeader = true;
	showSidebar = true;
	isHovered = false;

	get isSidebarCollapsed(): boolean {
		if (window.innerWidth <= 768) {
			return this.isMenuCollapsed;
		}
		return this.isMenuCollapsed && !this.isHovered;
	}

	onSidebarMouseEnter() {
		if (window.innerWidth > 768) {
			this.isHovered = true;
		}
	}

	onSidebarMouseLeave() {
		if (window.innerWidth > 768) {
			this.isHovered = false;
		}
	}

	constructor(private commonService: CommonService, private route: ActivatedRoute, private router: Router, private lang: TranslationService, private translate: TranslateService) {
		translate.addLangs(['en-US', 'hi-IN', 'mr-IN', 'bn-IN']);
		const currentLang = localStorage.getItem('lang') || 'en-US';
		translate.setDefaultLang(currentLang);
		translate.use(currentLang);
		this.browserLang = translate.getDefaultLang() || 'en-US';
		this.langChnaged();
		this.lang.selectLang.next(this.browserLang)
		this.checkRoute(this.router.url);
	}


	langChnaged() {
		const browserL = this.browserLang || 'en-US';
		this.translate.use(browserL.match(/en-US|hi-IN|mr-IN|bn-IN/) ? browserL : 'en-US')
	}

	checkRoute(url: string) {
		const isPublicPage = url.includes('terms-and-service') || url.includes('privacy-policy');
		if (isPublicPage) {
			this.showGlobalHeader = false;
			this.showSidebar = false;
		} else {
			this.showGlobalHeader = true;
			this.showSidebar = true;
		}
	}

	ngOnInit(): void {
		this.router.events.pipe(
			filter(event => event instanceof NavigationEnd)
		).subscribe((event: NavigationEnd) => {
			this.checkRoute(event.urlAfterRedirects || event.url);
			this.isHovered = false;
			if (window.innerWidth <= 768) {
				this.isMenuCollapsed = true;
			}
		});
	}

	// nav click..
	onNavClick(drawer) {
		this.commonService.toggleNavigationMenu(drawer)
	}
	
	@ViewChild(HeaderComponent)
	commonHeader: HeaderComponent;
  
	refreshNotification(flag){
		if (flag) {
			this.commonHeader.refreshNotification(flag);
		  }
	}

toggleMenu() { this.isMenuCollapsed = !this.isMenuCollapsed; }
}
